import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const DisciplinaCard = ({ className, id, nome }) => {
  return (
    <Link
      to={`disciplinas/${id}/edit`}
      className={`${className} card-100 card-body`}
    >
      <div className="d-flex justify-space-between">
        <p className="semi-bold brown text-underline">{nome}</p>
      </div>
    </Link>
  );
};

DisciplinaCard.propTypes = {
  className: PropTypes.string,
  nome: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
};

DisciplinaCard.defaultProps = {
  className: '',
};

export default DisciplinaCard;
